/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-config.js to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.REACT_APP_SITECORE_API_KEY || "{8C3D041E-BB12-4CC6-908A-4CF43E542E5B}";
config.sitecoreApiHost = process.env.REACT_APP_SITECORE_API_HOST || "https://mattamyhomes.com";
config.sitecoreSiteName = process.env.REACT_APP_SITECORE_SITE_NAME || "mattamy-homes";
config.graphQLEndpointPath = process.env.REACT_APP_GRAPH_QL_ENDPOINT_PATH || "/api/mattamy-homes";
config.defaultLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE || "en";
config.graphQLEndpoint = process.env.REACT_APP_GRAPH_QL_ENDPOINT || "https://mattamyhomes.com/api/mattamy-homes";
config.layoutServiceConfigurationName = process.env.REACT_APP_LAYOUT_SERVICE_CONFIGURATION_NAME || "jss";
module.exports = config;